// TODO make some graphs
import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { DataTable, Page, AppProvider, Card, Layout, Frame, Loading, Banner, Link } from '@shopify/polaris';

import GeneralStatsCard from './components/GeneralStatsCard';
import SaleReportStats from './components/SaleReportStats';
import SoldItemStats from './components/SoldItemStats';
import SaleReportOverview from './components/SaleReportOverview';
import esTranslations from 'utils/locales/es.json';

import axios from 'utils/axios';

const propTypes = {
  product: PropTypes.object.isRequired,
  // seller: PropTypes.object.isRequired,
  order_supply: PropTypes.object.isRequired,
  sale_report: PropTypes.shape({
    rows: PropTypes.array.isRequired,
  }),

  sale_report_items: PropTypes.shape({
    orders_count: PropTypes.number,
    sale_amounts: PropTypes.arrayOf(PropTypes.shape({
      currency_symbol: PropTypes.string.isRequired,
      amount: PropTypes.string.isRequired,
      currency_name: PropTypes.string.isRequired,
    })),
    sold_best: PropTypes.array,
    sold_less: PropTypes.array,
  }).isRequired,

  dateOptions: PropTypes.array.isRequired,
  filterURL: PropTypes.string.isRequired,

  sellerIsApu: PropTypes.bool,
  sellerIsNew: PropTypes.bool,
}

const defaultProps = {
  sellerIsApu: false
}

const SellerDashboard = (props) => {
  const [displayBanner, setDisplayBanner] = useState(props.sellerIsNew);
  const [loading, setLoading] = useState(false);
  const [salesOverview, setSalesOverview] = useState(props.sale_report_items);

  const closeBanner = () => setDisplayBanner(false);

  const submitFilter = async (dateEnum, customRange = {} ) => { // customRange as object with { start: date, end: date}
    setLoading(true)
    try {
      const response = await axios.post(props.filterURL, { date_enum: dateEnum, ...customRange });
      setSalesOverview(response.data.sale_report_items);
    } catch (error) {
      console.log("E", error);
    }
    setLoading(false)
  }

  if(props.sellerIsApu){
    return (
      <AppProvider i18n={ esTranslations } >
        <Frame>
          <Page
            fullWidth
          >
            { loading && <Loading /> }
            { displayBanner &&
              <div className="mb20">
                <Banner title="Conocé Unimart Seller" onDismiss={ closeBanner } >
                  <p>Seguí aprendiendo sobre Unimart Seller desde nuestro centro de ayuda.</p>
                  <Link external url="https://www.unimart.com/pages/vender">Aprender más</Link>
                </Banner>
              </div>
            }
            <Layout>
              <Layout.Section secondary>
                { props.sale_report.rows.length > 0 &&
                  <SaleReportStats rows={ props.sale_report.rows } />
                }
                <GeneralStatsCard title={ I18n.t("dashboard.transfer.stats") } total={ props.transfer.total } rows={ props.transfer.rows } /> 
                <GeneralStatsCard   title={ I18n.t("dashboard.product_stats") } total={ props.product.total } rows={ props.product.rows } />
              </Layout.Section>
  
              <Layout.Section>
                <Card>
                  {/* Graph and orders count */}
                  <SaleReportOverview 
                    loading={ loading } 
                    data={ salesOverview } 
                    dateOptions={ props.dateOptions } 
                    onFilter={ submitFilter } 
                  /> 
                </Card>
              </Layout.Section>
            </Layout>
          </Page>
        </Frame>
      </AppProvider>
    );
  }
  else{
    return(
      <AppProvider i18n={esTranslations}>
          <Page fullWidth>
            <Layout>
              <Layout.Section secondary>
                {/* TODO improve order supply stats */}
                <GeneralStatsCard title={ I18n.t("dashboard.order_supply.stats") } total={ props.order_supply.total } rows={[]} /> 
              </Layout.Section>

              <Layout.Section>
                <GeneralStatsCard   title={ I18n.t("dashboard.product_stats") } total={ props.product.total } rows={ props.product.rows } />
              </Layout.Section>
            </Layout>
          </Page>
      </AppProvider>
    )
  }

}


SellerDashboard.propTypes = propTypes;

export default SellerDashboard;